import { style } from '@vanilla-extract/css';
import { themeVars } from '../themeVars.css';

export const headerTitleClass = style({
  fontSize: 26,
  fontWeight: themeVars.font.weight.bold,
});
